import { createSlice } from '@reduxjs/toolkit';

export const RefreshmentPoModelSlice = createSlice({

    name: 'refreshmentPoModelSlice',
    initialState: {
        loading: false,
        error: '',
        data: [],
        updateSuccess: false,
        createTaskSuccess: false

    },
    reducers: {
        clearError: (state, action) => {
            return {
                ...state,
                error: action.payload
            }
        },
        clear: (state, action) => {
            return {
                ...state,
                [action.payload.key]: action.payload.value
            }
        }
    },
    extraReducers: (builder) => {
        // builder.addCase(getCall.pending, (state, action) => {
        //     state.loading = true;
        // })
        // builder.addCase(getCall.fulfilled, (state, action) => {
        //     state.loading = false;
        //     state.data = action.payload.data
        // })
        // builder.addCase(getCall.rejected, (state, action) => {
        //     state.error = action.payload.message
        //     state.loading = false;
        // })
    }
})

export const { clearError, clear } = RefreshmentPoModelSlice.actions

export default RefreshmentPoModelSlice.reducer